import styled from 'styled-components';
import { Radio } from 'antd';

// eslint-disable-next-line import/prefer-default-export
export const RadioGroup = styled(Radio.Group)`
  .ant-radio-wrapper {
    display: block;
    font-weight: normal;
    line-height: 35px;
  }
`;
